export const mediaTag = {
  headers: [
    {
      sortable: true,
      value: 'name',
      type: 'button',
      display: 'name',
    },
    {
      sortable: true,
      display: 'medias',
      value: 'medias',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: true,
      display: 'active',
      type: 'checkbox',
      value: 'is_deactivated',
    },
  ],
};

export const medicalCondition = {
  headers: [
    {
      sortable: true,
      value: 'name',
      type: 'button',
      display: 'name',
    },
    {
      sortable: true,
      display: 'users',
      value: 'users',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: true,
      display: 'active',
      type: 'checkbox',
      value: 'is_deactivated',
    },
  ],
};

export const scalpCondition = {
  headers: [
    {
      sortable: true,
      value: 'name',
      type: 'button',
      display: 'name',
    },
    {
      sortable: true,
      display: 'users',
      value: 'users',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: true,
      display: 'active',
      type: 'checkbox',
      value: 'is_deactivated',
    },
  ],
};

export const shop = {
  headers: [
    {
      sortable: true,
      isLink: true,
      linkName: 'editShop',
      value: 'name',
      display: 'name',
      width: '400',
    },
    {
      sortable: true,
      value: 'users',
      display: 'users',
      width: '100',
    },
    {
      sortable: true,
      value: 'address',
      display: 'address',
    },
    {
      sortable: true,
      value: 'country',
      display: 'country',
    },
    {
      sortable: false,
      value: '',
      display: '',
      width: '48',
    },
  ],
};

export const user = {
  headers: [
    {
      sortable: true,
      isLink: true,
      linkName: 'editUserMedia',
      display: 'full_name',
      value: 'full_name',
      width: '300',
    },
    {
      sortable: true,
      isNested: true,
      display: 'shop',
      value: 'shop_id',
      defaultValue: 'HQ',
    },
    {
      sortable: true,
      display: 'mobile',
      value: 'mobile',
    },
    {
      sortable: true,
      display: 'medias',
      value: 'medias',
    },
    {
      sortable: true,
      display: 'updatedAt',
      type: 'date',
      value: 'updatedAt',
    },
    {
      sortable: false,
      display: '',
      value: '',
      width: '48',
    },
  ],
};

export const log = {
  headers: [
    {
      sortable: false,
      display: 'date',
      value: 'date',
      width: '200',
    },
    {
      sortable: false,
      display: 'shop',
      value: 'shop',
      width: '200',
    },
    {
      sortable: false,
      display: 'message',
      value: 'message',
    },
  ],
};
